// extracted by mini-css-extract-plugin
export default {"pad":"Products_pad__oV-eU","spac":"Products_spac__NNqJA","fs9":"Products_fs9__wNn8K"};